import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { SpecificationState } from '../../types/specification';
import type { SpecificationModel } from '../specification-model';
import { SpecificationStep } from '../../enums';

@injectable()
export class SpecificationModelImpl extends AbstractModel<SpecificationState> implements SpecificationModel {
    protected _modelData: SpecificationState = {
        taskId: '',
        currentStep: SpecificationStep.Create,
        wireframeExtractConfig: {
            enabled: false,
            remainingCount: 0,
            totalCount: 0,
        },
    };

    get modelData(): SpecificationState {
        return this._modelData;
    }
}
